import { Provider } from '@angular/core';

import { PayslipsRepositoryImpl } from '@app/data/repositories/ptrab/payslips/payslips.repository';
import { PAYSLIPS_REPOSITORY } from '@app/domain/repositories/ptrab/payslips/payslips.repository.contract';

export const payslipsRepositoryProvider: Provider = {
  provide: PAYSLIPS_REPOSITORY,
  useClass: PayslipsRepositoryImpl
};
